import FORMS from '../../../store/forms/formsConfigs/constants';

import FormsConfigs from '../../../store/forms/formsConfigs/formsConfigs';

import RegistratUser from './FormsComponents/RegistratUser/RegistratUser';
import RegistratUserOrg from './FormsComponents/RegistratUserOrg/RegistratUserOrg';
import RegistratUserOrgResult from './FormsComponents/RegistratUserOrgResult/RegistratUserOrgResult';

import SmsSign from './FormsComponents/SmsSign/SmsSign';
import ErrorDialog from './FormsComponents/ErrorDialog/ErrorDialog';

import PasswordForm from './FormsComponents/PasswordForm/PasswordForm';
import PasswordHintsForm from './FormsComponents/PasswordHintsForm/PasswordHintsForm';

import UserInfoForm from './FormsComponents/UserInfoForm/UserInfoForm';

import ErrorForm from './FormsComponents/ErrorForm/ErrorForm';

const components = {
  [FORMS.REGISTRAR_USER]: RegistratUser,
  [FORMS.REGISTRAR_USER_ORG]: RegistratUserOrg,
  [FORMS.REGISTRAR_USER_ORG_RESULT]: RegistratUserOrgResult,
  [FORMS.SIGN_SMS]: SmsSign,
  [FORMS.ERROR_DIALOG]: ErrorDialog,
  [FORMS.PASSWORD]: PasswordForm,
  [FORMS.PASSWORD_HINT]: PasswordHintsForm,
  [FORMS.USER_INFO]: UserInfoForm,
  [FORMS.ERROR_FORM]: ErrorForm
};

const getByName = name => {
  const key = FormsConfigs.getIdByName(name);
  return key ? components[key] : null;
};

export default {
  getByName
};



// WEBPACK FOOTER //
// ./src/components/containers/Forms/formsComponentsConfig.js